import { useTranslation } from 'react-i18next';

import { AlertDialog, Button } from '~/components';

type Props = {
  loading?: boolean;
  onConfirm: () => void;
};

export const StartFollowUpDialog = ({ loading, onConfirm }: Props) => {
  const { t } = useTranslation(['invoices']);

  return (
    <AlertDialog.Body status="danger">
      <AlertDialog.Title>{t('invoices:details.followUp.modal.title')}</AlertDialog.Title>

      <AlertDialog.Description>{t('invoices:details.followUp.modal.message')}</AlertDialog.Description>

      <AlertDialog.Actions>
        <Button icon="Gavel" loading={loading} onClick={onConfirm}>
          {t('invoices:details.followUp.modal.accept')}
        </Button>
      </AlertDialog.Actions>
    </AlertDialog.Body>
  );
};
